import React from 'react';
import shortid from 'shortid';
import CallOutToTab from './CallOutToTab';
import FallbackComponent from './FallbackComponent';
import FloorSelector from './GeoCommFloorSelector';

/**
 * Normalize the component name to pascal case for component naming convention
 * @param {String} n - the name of the component. words are dash separated
 */
const normalizeComponentName = n => {
  return n
    .split('-')
    .map(s => s[0].toUpperCase() + s.slice(1))
    .join()
    .replace(/,/g, '');
};

const Components = {
  CallOutToTab: props => <CallOutToTab key={shortid.generate()} {...props} />,
  FloorSelector: props => <FloorSelector key={shortid.generate()} {...props} />,
  Default: props => <FallbackComponent key={shortid.generate()} {...props} />,
};

export const getComponentToRender = props => {
  const schema = props.schema;
  const normalizedName = normalizeComponentName(
    schema.componentProperties.name,
  );

  const Component = Components[`${normalizedName}`];
  if (Component) {
    return () => <Component {...props} />;
  }

  // If the corresponding data doesn't contain details for the component,
  // render the fallback component
  return () => <Components.Default {...props} />;
};
